import * as React from 'react'

import {
  ReadMore,
  CombinedThemeInterface,
} from '@thg-commerce/gravity-patterns'
import {
  RichContent,
  SimpleTextReadMore,
} from '@thg-commerce/enterprise-network/src/generated/graphql'
import { i18n } from '@thg-commerce/enterprise-core'
import { HorizontalAlignment } from '@thg-commerce/enterprise-widget-accordion-container'
import { spacing, styled } from '@thg-commerce/gravity-theme'

import { BaseWidgetProps } from '../types'

interface SimpleTextReadMoreText {
  simpleTextReadMoreText: RichContent
}
export type SimpleTextWidgetRendererProps = BaseWidgetProps &
  Omit<SimpleTextReadMore & SimpleTextReadMoreText, 'query'>

const SIMPLE_TEXT_READ_MORE_DEFAULT_ALIGN = 'center'

const SimpleTextReadMoreContainer = styled.div`
  margin: 0 ${spacing(4)} ${spacing(2)};
`

const TitleContainer = styled.div<{
  horizontalAlignment?: string
}>`
  ${(props) =>
    props.horizontalAlignment === HorizontalAlignment.CENTER &&
    `text-align: center;`}
`

export const SimpleTextReadMoreRenderer = (
  props: SimpleTextWidgetRendererProps & { theme: CombinedThemeInterface },
) => {
  const i18nText = {
    readMore: i18n('general.readmore.text'),
    readLess: i18n('general.readless.text'),
  }

  const horizontalAlignment: string =
    props.simpleTextReadMore_textAlign || SIMPLE_TEXT_READ_MORE_DEFAULT_ALIGN

  return (
    <SimpleTextReadMoreContainer>
      <TitleContainer
        horizontalAlignment={horizontalAlignment}
        as={props.simpleTextReadMore_titleIsH1 ? 'h1' : 'h2'}
      >
        {props.simpleTextReadMore_title}
      </TitleContainer>
      <ReadMore
        content={props.simpleTextReadMoreText.content[0].content}
        readMoreText={i18nText.readMore}
        readLessText={i18nText.readLess}
        horizontalAlignment={horizontalAlignment}
        contentHorizontalAlignment={horizontalAlignment}
      />
    </SimpleTextReadMoreContainer>
  )
}
